import React from "react"

const Loader = () => {
    const style = {
        position: "fixed",
        zIndex: 10,
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        width: "100%",
        height: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    }

    const style2 = {
        background: "#000",
        opacity: "0.6",
        position: "absolute",
        left: 0,
        right: 0,
        top: 0,
        bottom: 0,
    }

    return (
        <div style={style}>
            <div style={style2}/>
            <div>
                <div className="spinner-wave">
                    <div className="wave1"/>
                    <div className="wave2"/>
                    <div className="wave3"/>
                    <div className="wave4"/>
                </div>
            </div>
        </div>
    )
}

export default Loader



// WEBPACK FOOTER //
// ./src/components/layouts/loader/loader.js